import { Reducer } from 'redux';
import { Action } from 'Store/types';

export enum ActionTypes {
  SET_ITS_MATCH = '@itsMath/SET',
}

export type SearchMatch = any;
export type SearchMatchReducer = Reducer<SearchMatch, Action<ActionTypes>>;
